import { render, staticRenderFns } from "./CommonAlertUi.vue?vue&type=template&id=6f2e4778&scoped=true&"
import script from "./CommonAlertUi.vue?vue&type=script&lang=js&"
export * from "./CommonAlertUi.vue?vue&type=script&lang=js&"
import style0 from "./CommonAlertUi.vue?vue&type=style&index=0&id=6f2e4778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e4778",
  null
  
)

export default component.exports